// extracted by mini-css-extract-plugin
export default {"errorNotificator":"styles_errorNotificator__nOs-t"};